if (!customElements.get('dfc-tote-personalization')) {
  customElements.define('dfc-tote-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.info = this.closest('product-info');
      this.form = this.closest('form');
      this.input = this.querySelector('[name="properties[Name]"]');
      this.font = this.querySelector('[data-tote-font]');
      this.fields = this.querySelector('[data-tote-name-fields]');
      this.count = this.querySelector('[data-tote-count]');
      this.preview = this.info.querySelector('dfc-tote-preview');
      this.variant = JSON.parse(this.querySelector('[data-tote-variants]').textContent);
      this.input.addEventListener('input', () => {
        this.input.setCustomValidity('');
        this.count.textContent = `${Array.from(this.input.value).length} / 15`;
        this.drawName();
      });
      this.variantInput = this.form.querySelector('[name="id"]');
      this.toggle = this.querySelector('[data-add-tote-name]');
      this.paidVariants = JSON.parse(this.querySelector('[data-paid-tote-variants]').textContent || '[]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency });
      this.toggle.addEventListener('change', () => this.sync());
      this.onSubmit = event => {
        this.sync();
        if (!this.personalized) return;
        const name = this.input.value.trim();
        const length = Array.from(name).length;
        this.input.setCustomValidity(!length ? this.dataset.requiredMessage : length > 15 ? this.dataset.limitMessage : '');
        if (!this.input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
          this.input.focus();
          return;
        }
        this.input.value = name;
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === String(this.info.dataset.section)) this.sync(data.variant);
      });
      this.onPageShow = () => requestAnimationFrame(() => this.sync());
      window.addEventListener('pageshow', this.onPageShow);
      this.sync();
      document.fonts?.load('200px Creepster').then(() => this.drawName());
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.onPageShow);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.initialized = false;
    }
    sync(variant = this.variant) {
      this.variant = variant;
      const paid = this.paidVariants.find(item => item.options[0] === variant?.options?.[0]);
      this.toggle.disabled = !paid?.available;
      this.personalized = this.toggle.checked && !!paid?.available;
      this.checkoutVariant = this.personalized ? paid : variant;
      if (this.checkoutVariant) this.variantInput.value = String(this.checkoutVariant.id);
      const price = this.info.querySelector(`[id="price-${this.info.dataset.section}"]`);
      price?.querySelectorAll('.price-item--regular, .price-item--sale').forEach(item => {
        item.textContent = this.money.format((this.checkoutVariant?.price || 0) / 100);
      });
      this.fields.hidden = !this.personalized;
      this.input.disabled = !this.personalized;
      this.input.required = this.personalized;
      this.font.disabled = !this.personalized;
      if (!this.personalized) this.input.setCustomValidity('');
      const image = this.preview?.querySelector('img');
      const normalSource = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
      const namedSource = this.preview?.querySelector(`[data-tote-design="${variant?.id}"]`)?.dataset.source;
      const source = this.personalized && namedSource ? namedSource : normalSource;
      if (image && source && image.dataset.previewKey !== `${variant.id}-${this.personalized}`) {
        image.removeAttribute('srcset');
        image.src = source;
        image.dataset.previewKey = `${variant.id}-${this.personalized}`;
        image.alt = variant.title;
      }
      this.drawName();
    }
    drawName() {
      const svg = this.preview?.querySelector('svg');
      const text = svg?.querySelector('text');
      if (!text) return;
      svg.toggleAttribute('hidden', !this.personalized);
      if (!this.personalized) return;
      text.textContent = this.input.value.trim() || this.dataset.example;
      this.measureContext ||= document.createElement('canvas').getContext('2d');
      const context = this.measureContext;
      context.font = '200px Creepster, Arial, sans-serif';
      const metrics = context.measureText(text.textContent);
      const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
      const width = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight;
      if (!width || !height) return;
      const scale = Math.min(132 / height, 660 / width);
      text.setAttribute('font-size', String(200 * scale));
      text.setAttribute('x', String(627 - (metrics.actualBoundingBoxRight - metrics.actualBoundingBoxLeft - metrics.width) * scale / 2));
      text.setAttribute('y', String(286 + metrics.actualBoundingBoxAscent * scale));
    }
  });
}
